import { z } from 'zod';
import { BasicAnimationSetSchema } from './animations';
import { BasePinComponentSchema, BasePinComponentSettingsSchema } from './base-pin-component';

const SliceColorIdentifierSchema = z.enum(['first', 'second', 'third']);

export const SpinnerPinComponentPinThemeSettingsSchema = z.object({
  sliceColors: z
    .partialRecord(
      SliceColorIdentifierSchema,
      z.object({
        backgroundColor: z.string(),
        textColor: z.string(),
      })
    )
    .optional(),
});
export type SpinnerPinComponentPinThemeSettings = z.infer<typeof SpinnerPinComponentPinThemeSettingsSchema>;

const SpinnerSettingsSchema = BasePinComponentSettingsSchema.extend(
  SpinnerPinComponentPinThemeSettingsSchema.extend(
    z.object({
      options: z.array(z.string()).optional(),
      animations: BasicAnimationSetSchema.optional(),
    }).shape
  ).shape
);
export type SpinnerSettings = z.infer<typeof SpinnerSettingsSchema>;

export const SpinnerPinComponentTypeSchema = z.literal('SPINNER');

export const SpinnerPinComponentSchema = BasePinComponentSchema.extend(
  z.object({
    type: SpinnerPinComponentTypeSchema,
    settings: SpinnerSettingsSchema,
  }).shape
);
